import { Box, Divider, Grid, PageWrapper, useLayout } from '@approvalmax/ui/src/components';
import { hocs as pageHocs } from 'modules/page';
import { memo, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { routingService } from 'services/routing';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';
import { usePermissions } from 'shared/hooks/usePermissions';

import { ContactList } from './resources/components/ContactList/ContactList';
import { InfoPanel } from './resources/components/InfoPanel/InfoPanel';
import { useContactPaymentDetailsBreadcrumbs } from './resources/hooks/useBreadcrumbs';
import { useContactList } from './resources/hooks/useContactList';
import { messages } from './resources/messages';

const Page = memo(() => {
    useLayout({ hasHeader: true, hasDrawer: true });

    useContactPaymentDetailsBreadcrumbs();

    const company = useCompanyBasedOnUrl();

    const { isPaymentDetailsViewEnabled } = usePermissions(company);

    const {
        data: contactList,
        isFetching,
        isFetchingNextPage,
        fetchNextPage,
        activeContact,
        updateCachedData,
    } = useContactList();

    useEffect(() => {
        if (!isPaymentDetailsViewEnabled) {
            routingService.replaceToDefaultPath();
        }
    }, [isPaymentDetailsViewEnabled]);

    return (
        <PageWrapper>
            <Helmet
                title={messages.title({
                    companyName: company?.displayName,
                })}
            />

            <Grid height='100%' gridTemplateColumns='442px max-content auto'>
                <Box height='100%' overflowY='hidden'>
                    <ContactList
                        data={contactList}
                        isFetching={isFetching}
                        isFetchingNextPage={isFetchingNextPage}
                        fetchNextPage={fetchNextPage}
                    />
                </Box>

                <Divider color='midnight50' orientation='vertical' />

                <Box height='100%' overflowY='hidden'>
                    <InfoPanel activeContact={activeContact} updateContactListCacheData={updateCachedData} />
                </Box>
            </Grid>
        </PageWrapper>
    );
});

export default pageHocs.withProtected({ Page });
